import { createSlice } from '@reduxjs/toolkit'

const authStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: null,
    errorMessage: null,
    responseData: null,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        submitFormRequest: state => {
            state.status = authStatus.LOADING
        },
        submitFormRequestSuccess: (state, action) => {
            state.status = authStatus.SUCCESS
            state.responseData = action.payload.data
        },
        submitFormRequestError: (state, action) => {
            state.status = authStatus.FAILURE
            state.errorMessage = action.payload.error
        },
        resetState: state => initialState,
    },
})

const {
    submitFormRequest,
    submitFormRequestSuccess,
    submitFormRequestError,
    resetState,
} = authSlice.actions

export const authActions = {
    submitFormRequest,
    submitFormRequestSuccess,
    submitFormRequestError,
    resetState,
}

export const authSelectors = {
    getIsFetchingState: state => state.auth.status === authStatus.LOADING,
    getHasErrorState: state => state.auth.status === authStatus.FAILURE,
    getSuccessState: state => state.auth.status === authStatus.SUCCESS,
    getErrorMessageState: state => state.auth.errorMessage,
    getResponseDataStatus: state => state.auth.responseData,
}

export default authSlice.reducer
